import React from "react";
import "./AnalyticsConsult.css";
import img from "../analyticassets/consult.png";

export default function AnalyticsConsult() {
  return (
    <div id="analytics-consult" className="outsourcemainclass">
    <div className="top">
          <div className="right">
        <h2 className="heading">What Is DevOps Scalability?</h2>
        <p className="subheading">
          DevOps scalability is the practice of designing systems, applications,
          and infrastructure that can dynamically adapt to changing workloads.
          By combining automation, cloud-native technologies, and DevOps best
          practices, scalability ensures applications can grow or shrink based
          on demand, delivering consistent performance, high availability, and
          cost efficiency.
        </p>
     </div>
        <div className="left">
        <img src={img} alt="error" />
      </div>
    </div>
    <div className="bottom">
         <div id='counter'>
        <div className="count">
          <h2>41%</h2>
          <span>
           Projects Completed
          </span>
        </div>
        <div className="count">
          <h2>21%</h2>
          <span>
           Faster Time-to-Market
          </span>
        </div>
        <div className="count">
          <h2>7h</h2>
          <span>
           System Reliability
          </span>
        </div>
        <div className="count">
          <h2>60%</h2>
          <span>
           Cost Optimization Achieved
          </span>
        </div>
      </div>
    </div>
    </div>
  );
}
